import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordian";
import PaymentStepsCard, { PaymentSectionDataProps } from "@components/integration/PaymentStepsCard";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { GoArrowUpRight } from "react-icons/go";

interface PaymentGateWay {
    icon: string;
    title: string;
    descritpion: string;
    externalLink: string;
}

const paymentGateWayData: PaymentGateWay[] = [
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/Calendly/zoho-booking.svg",
        title: "Zoho Bookings",
        descritpion: "Simplify appointment scheduling and get notified whenever a booking comes through",
        externalLink: "https://gallabox.com/whatsapp-integrations/zoho",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/Calendly/zoho-meeting.svg",
        title: "Zoho Meetings",
        descritpion: "Connect Zoho Meetings with Gallabox to automate reminder sequences and more.",
        externalLink: "https://gallabox.com/whatsapp-integrations/zoho",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/Calendly/calendy.svg",
        title: "Calendly",
        descritpion: "Integrate Calendly with your WhatsApp number to get real-time updates on every demo booking",
        externalLink: "https://gallabox.com/whatsapp-integrations/calendly",
    },

    {
        icon: "https://assets.gallabox.com/gb-home/integrations/Calendly/zoom-connector.svg",
        title: "Zoom Connector",
        descritpion: "The best connector for streamlining webinar registrations through WhatsApp",
        externalLink: " https://docs.gallabox.com/bots/bot-connectors/zoom-whatsapp-integration-how-to-enable-webinar-registration-on-whatsapp",
    },
];

const featureInfo1: FeatureInfo = {
    mainTitle: "AI-powered workflows",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/ai-power-flow.png",
    featureInfoList: ["Set up complex workflows without code", "Follow up with nudges and reminders to encourage show-ups", "Make rescheduling options accessible for users"],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Effortless plug-n-play setup",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/effortless-plugin.png",
    featureInfoList: ["Connect your accounts without extensive walkthroughs", "Eliminate development effort", "Update and replace connections without a hassle"],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Personalized nurturing sequences",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/integral.png",
    featureInfoList: [
        "Send tailored message reminders based on booking types",
        "Use rich media to push more qualified calls",
        "Deploy tailored prompts to collect better data before your calls",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Integral integrations",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/hero-image.png",
    featureInfoList: [
        "Integrate with your CRM for seamless customer service",
        "Process payments easily using payment integrations",
        "Ensure product delivery through logistics integrations",
    ],
};

const productCardData: Array<Product> = [
    {
        title: "Rich media messaging",
        description: "Leverage rich media [images, videos, and more] to nudge users further and ensure show-ups.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-call.svg",
        headerBackground: true,
    },
    {
        title: "Localized communication",
        description: "Use custom language preferences to personalize messages to customers across the world.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
        headerBackground: true,
    },
    {
        title: "Conversational bot support",
        description: "Provide consultations before calls through live or automated chats. Help mitigate concerns before your demos",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
        headerBackground: true,
    },
    {
        title: "Auto reminders and follow-ups",
        description: "Deploy auto-reminder bots that make sure your prospects and clients show up for calls without you lifting a finger",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/dollar.svg",
        headerBackground: true,
    },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/case-study/thread-bucket-studio/thread-bucket-studio.png",
        chiptitle: "E-commerce",
        title: "Why Thread Bucket Studio chose Gallabox over Wati for seamless team communication",
        statsInfoData: [
            { percentage: "68%", label: "Higher business growth" },
            { percentage: "50%", label: "Rise in employee productivity" },
            { percentage: "30%", label: "Growth in customer base" },
        ],
        url: "https://gallabox.com/case-study/thread-bucket-studio",
        cardColor: true,
    },
];

const paymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/integration-navigator.png",
        title: "Navigate to Integrations section",
        description:
            "Head over to the Integrations pane of your Gallabox account. You’ll find a list of all your favourite calendar integrations, including WhatsApp Google Calendar integration",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/calendy-account.png",
        title: "Connect your Calendar account",
        description: "Select your preferred Calendar, and connect your account.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/calendy-settings.png",
        title: "Configure the Settings",
        description: "Choose your preferred WhatsApp channel and configure it.",
    },
];

const defaultFAQData: FAQSectionProps = {
    title: "FAQs about WhatsApp calendar integration",
    faqItems: [
        {
            question: "What is WhatsApp Calendar Integration?",
            answer: (
                <div>
                    Using a Whatsapp automation tool like Gallabox, you can integrate your calendars - whether its your Google Calendar, or any other one - to your WhatsApp number,
                    and receive meeting updates, reminders, and more.
                </div>
            ),
        },
        {
            question: "Can I schedule appointments or meetings directly through WhatsApp after the integration?",
            answer: <>Yes, you should be able to use Gallabox’s WhatsApp bot to book appointments and schedule meetings directly from WhatsApp</>,
        },
        {
            question: "Can customers book appointments with me via WhatsApp using calendar integration?",
            answer: (
                <p>
                    Yes, customers will be able to get in touch with your business through WhatsApp, and book appointments at specific times (you can set these up as well). They
                    will also receive automatic reminders for their meetings through Gallabox
                </p>
            ),
        },
        {
            question: "How can I send appointment reminders and confirmations through WhatsApp with calendar integration?",
            answer: (
                <div>
                    Yes, you should be able to use Gallabox to create personalised nudges and follow-ups to ensure more people make it to your meetings, webinars, and demo calls.
                </div>
            ),
        },
        {
            question: "Is it possible to sync multiple calendars (personal and business) with WhatsApp?",
            answer: <div>Yes, of course, you can connect multiple calendars to your WhatsApp number through Gallabox.</div>,
        },
        {
            question: "How secure is my calendar data when integrating it with WhatsApp?",
            answer: <>Gallabox is compliant with GDPR and SOC2 guidelines, so you can rest assured that your calendar data is completely secure.</>,
        },
        {
            question: "Can I customize my calendar notifications sent through WhatsApp?",
            answer: <p>Yes, you can customize your follow-up and reminder notifications using a WhatsApp automation solution like Gallabox.</p>,
        },
        {
            question: "Can I view and manage my calendar events directly within WhatsApp after integration?",
            answer: (
                <p>
                    Yes, you can customize your WhatsApp chatbot through Gallabox to display your upcoming and past meetings, and then schedule or reschedule meetings to align with
                    your priorities
                </p>
            ),
        },
        {
            question: "Does WhatsApp Calendar Integration support rescheduling or cancellations of appointments?",
            answer: (
                <p>
                    Yes, you can connect your calendar to your WhatsApp through Gallabox, and allow clients to schedule, reschedule, or cancel appointments with your business
                    straight through WhatsApp
                </p>
            ),
        },
        {
            question: "How do I handle time zone differences with WhatsApp Calendar Integration?",
            answer: (
                <div>
                    Gallabox supports multiple timezones, so you should be able to fairly easily handle appointment scheduling across multiple timezones, and sync them with the
                    timezone in your calendar.
                </div>
            ),
        },
        {
            question: "Does WhatsApp Calendar Integration allow for group scheduling and managing multiple participants?",
            answer: (
                <div>
                    Yes, you can schedule meetings for multiple participants, straight from WhatsApp. With Gallabox, you can use WhatsApp to schedule appointments and add
                    participants to those meetings/events.
                </div>
            ),
        },
        {
            question: "Is WhatsApp Calendar Integration compatible with all types of business calendars?",
            answer: <div>Yes, you will be able to connect your WhatsApp number to your Google Calendar, Zoom, Calendly, Zoho Meetings, and more.</div>,
        },
        {
            question: "Can I use WhatsApp Calendar Integration for both one-on-one and group events or meetings?",
            answer: (
                <div>
                    Yes, you can use Gallabox and WhatsApp to connect your calendar to your WhatsApp number, and schedule personal or group events effortlessly with your contact
                    base.
                </div>
            ),
        },
    ],
};

const herosectionData: HerosectionProps = {
    chipTitle: "INTEGRATION",
    title: "Calendar looking like a chaotic war zone?",
    description: "Eliminate double bookings, minimize client no shows, and handle scheduling like a boss with Gallabox’s WhatsApp calendar integration.",
    primaryButtonText: "Start your free trial now",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/hero-image.png",
    backgroundColor: true,
};

const paymentAccordianData: PaymentProcess = {
    title: "How to integrate Gallabox with your calendar in 3 simple steps?",
    ProcessSteps: [
        {
            title: "Navigate to Integrations section",
            description: "Simply go to the integrations pane of your Gallabox account. Select from a list of calendars, including WhatsApp Calendar integration",
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/payment-link.png",
        },
        {
            title: "Connect your Calendar account",
            description: "Simply select your Calendar, and connect your account.",
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/payment-update.png",
        },
        {
            title: "Configure the Settings",
            description: "Choose your preferred WhatsApp channel and configure it.",
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/Calendly/personalize-broadcast.png",
        },
    ],
};

const Calendar: React.FC = () => {
    return (
        <NewLayout
            title={"Automate Your Scheduling with WhatsApp Calendar Integration"}
            description={"Boost conversions with WhatsApp calendar integration—automate your scheduling, sync with tools like Google Calendar, and streamline customer follow-ups."}
            canonical={"https://gallabox.com/integrations/payment/whatsapp"}
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/whatsapp-marketing/wa-integration-og.png" }}
        >
            <Herosection herosection={herosectionData} />

            <section className="mt-20 mb-20">
                <div className="w-full">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>
            </section>
            <section className={`${container_classname} mb-20`}>
                <h3 className="mb-5 md:text-6xl text-4xl">Why integrate your calendar with WhatsApp?</h3>
                <p>
                    Demo bookings, sales calls, service appointments — sometimes, your most important prospects contact you while you’re away, and keeping track of all of them can
                    become a hassle. With Gallabox, managing this mess becomes a piece of cake.
                    <br />
                    <br />
                    Simply connect your WhatsApp with any Calendar across your tech stack, and get meeting details sent straight to your inbox
                </p>

                <section className="grid md:grid-cols-3 gap-6 mt-9">
                    {paymentGateWayData.map((paymentGate, idx) => {
                        return (
                            <a className="p-5 border border-gray-200 border-solid rounded-md hover:no-underline" key={idx} href={paymentGate.externalLink}>
                                <div className="flex gap-5 mb-9">
                                    <img src={paymentGate.icon} alt="" width={64} height={64} />
                                    <div className="flex flex-col gap-1">
                                        <p>{paymentGate.title}</p>
                                        <p>payment</p>
                                    </div>
                                </div>
                                <p>{paymentGate.descritpion}</p>
                                <GoArrowUpRight size={20} className="mt-5 ml-auto" />
                            </a>
                        );
                    })}
                </section>
            </section>

            <section className="lg:block hidden">
                <PaymentStepsCard title={"Best practices for using WhatsApp calendar integration"} paymentSectionData={paymentSectionData} />
            </section>
            <PaymentStepsAccordion paymentStepsData={paymentAccordianData} />

            <div className={`${container_classname} pt-20`}>
                <h4 className="md:text-7xl text-4xl">Key benefits of WhatsApp calendar integration</h4>
                <p className="mt-9">
                    Let’s be real — integrating WhatsApp with your CRM isn’t just about connecting two systems. It’s about creating conversations that convert and relationships
                    that last. Here’s how top-performing businesses make it work (without the tech headaches):
                </p>
            </div>

            <section>
                <FeatureInfoCard {...featureInfo1} />
                <FeatureInfoCard {...featureInfo2} />
                <FeatureInfoCard {...featureInfo3} />
                <FeatureInfoCard {...featureInfo4} />
            </section>
            <ProductSection title="Best practices for using WhatsApp Payment Integration" productCardData={productCardData} />

            <section>
                <CaseStudyFeatureSection features={caseStudyFeatureCardData} backgroundColor={true} />
            </section>

            <FAQSection faqData={defaultFAQData} />

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Integrate your payment gateway with Gallabox now!" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default Calendar;
